import React, { useContext } from 'react';
import { IconLogoGoldie } from '@wds/icons';
import { Immutable } from '@wds/utils';
import { defineMessages, t } from '@sm/intl';
import { generateMetricsAttribute } from '@sm/metrics';

import { useHeaderTheme } from '../../theme';
import useStyles from './useStyles';
import HeaderContext from '../../HeaderContext';

export const COPY = defineMessages({
  LOGO: {
    id: 'Logo.logoLabel',
    defaultMessage: 'Brand logo',
    description:
      '[Type: Label][Vis.: high] - This is the brand logo on the header.',
  },
});

export type LogoProps = Immutable<{
  label?: string;
  link: string;
}>;

export const Logo = ({
  label = t(COPY.LOGO),
  link,
}: LogoProps): React.ReactElement => {
  const theme = useHeaderTheme();
  const classes = useStyles({ theme });

  const { pageURL, pageName } = useContext(HeaderContext);

  return (
    <span
      className={classes.logo}
      aria-label="logo"
      data-sm-metrics={generateMetricsAttribute({
        data: {
          url: pageURL,
          pageName,
          amplitudeEvent: 'header clicked navigation',
          navItem: 'logo',
        },
      })}
    >
      <a href={link} className={classes.logo}>
        <IconLogoGoldie title={label} size="xl" />
      </a>
    </span>
  );
};
